import React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';

import { UIState } from '@/model/global/types';
import { TransactionsPageView } from '@/pages/wallets/components';

export const TransactionsPage: React.FC<RouteComponentProps> = ({ location }) => {
  const scrollToTx = location.hash.replace('#', '');
  return <TransactionsPageView basePath={UIState.WALLETS} scrollToTx={scrollToTx} hideBalance data-test="transactions" />;
};

export default withRouter(TransactionsPage);
